/**
 * Route for `bulk-targeting`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { BulkTargetingPage } from "../features/bulk-targeting/BulkTargetingPage";

export const bulkTargetingRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/bulk-targeting",
	component: BulkTargetingPage,
});

export default bulkTargetingRoute;
